<template>
  <div>
    <div class="row-width-actions-bar is-border-bottom">
      <div class="columns is-gapless">
        <div
          class="column is-narrow is-border-right">
          <span class="button page-header-btn is-small is-square">
            <span class="icon is-size-4"><i class="fal fa-file-alt"></i></span>
          </span>
        </div>
        <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
          <div class="column is-narrow">
            <input
              class="is-checkradio is-success"
              :id="'custom-contract-' + index"
              type="radio"
              :name="'contract'"
              @input="updateContractUsed(item.pk)"
              :checked="useCustomContract == item.pk">
            <label
              class="is-padding-right"
              :for="'custom-contract-' + index"><span
                class="is-size-6">{{ item.name }}</span></label>
          </div>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="!askRemoveLine">
          <router-link
            :to="{name: 'ContractEdit', params: {id: item.pk, program_id: programPk}}">
            <a
              class="page-header-btn is-small is-square tooltip is-tooltip-top"
              data-tooltip="Modifier le modéle">
              <span class="icon is-size-4"><i class="fal fa-pencil"></i></span>
            </a>
          </router-link>
        </div>
        <div
          class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            @click="askRemove('askRemoveLine')"
            data-tooltip="Retirer le modèle">
            <span class="icon is-size-4"><i class="fal fa-trash-alt"></i></span>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="askRemoveLine">
          <a
            class="page-header-btn is-small is-danger is-striped"
            @click="removeLine">
            <span class="is-size-7">Confirmer le retrait du modèle du programme</span>
          </a>
        </div>
        <div
          class="column is-narrow is-border-left"
          v-if="askRemoveLine">
          <a
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            data-tooltip="Annuler suppression de la ligne"
            @click="cancelRemove">
            <i class="fal fa-times"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'ContractListItem',
  props: {
    currentContract: {
      type: String
    },
    source: {
      type: Object
    },
    index: {
      type: Number
    },
    programPk: {
      type: String
    },
    selectedRow: {
      type: String
    },
    openInput: {
      type: Boolean,
      default: false
    },
    useCustomContract: {
      type: String
    }
  },
  data () {
    return {
      validDocument: null,
      editionMode: false,
      uploading: false,
      askRemoveLine: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur']),
    ...mapState(['modal']),
    /**
      * return source as item
      * @returns {object}
      */
    item () {
      return this.source
    }
  },
  watch: {
    selectedRow (v) {
      if (v !== 'document-' + this.index) {
        this.cancelRemove()
      }
    }
  },
  methods: {
    /**
      * update item
      */
    updateContractUsed (val) {
      this.$emit('updateContractUsed', val)
    },
    /**
      * remove line
      */
    removeLine () {
      this.$emit('remove', this.item.pk)
      this.cancelRemove()
    },
    /**
      * cancel remove
      */
    cancelRemove () {
      this.askRemoveLine = false
    },
    /**
      * ask remove
      * @param {string} key
      */
    askRemove (key) {
      this[key] = true
      this.toggleDisplayButtons()
    },
    /**
      * toggle display buttons
      */
    toggleDisplayButtons () {
      this.$emit('selectedRow', 'document-' + this.index)
    }
  }
}
</script>
